<template>
	<div>
		<div style="
		color: #3e3e3e;
		font-size: 18px;margin-bottom: 15px;">
			门店管理>排班管理>{{activenum=="a"?"班次设置":""}}{{activenum=="b"?"排班审核":""}}{{activenum=="e"?"导入排班":""}}{{activenum=="f"?"导入排班":""}}
		</div>
		<el-tabs type="border-card" v-model="activenum">
			<el-tab-pane name="a" label="班次设置">
				<list1 v-if="activenum=='a'"></list1>
			</el-tab-pane>
			<el-tab-pane name="e" label="导入排班">
				<list5 v-if="activenum=='e'"></list5>
			</el-tab-pane>
			<el-tab-pane name="f" label="导入排班">
				<list2 v-if="activenum=='f'"></list2>
			</el-tab-pane>
			<el-tab-pane name="b" label="排班审核">
				<list6 v-if="activenum=='b'"></list6>
			</el-tab-pane>
			<el-tab-pane name="d" label="班组设置">
				<list4 v-if="activenum=='d'"></list4>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<script>
	import list1 from "./typesetting/typesetting1.vue"
	import list2 from "./typesetting/typesetting2.vue" //导入排班
	import list6 from "./typesetting/typesetting6.vue" //排班审核
	import list4 from "./typesetting/typesetting4.vue"
	import list5 from "./typesetting/typesetting5.vue" //导入排班2

	export default {
		components: {
			list1,
			list2,
			list4,
			list5,
			list6
		},
		data() {
			return {
				activenum: "e"
			};
		},
		methods: {
			// tabs切换点击事件
			tabsSwitch(id) {
				this.tabs.forEach((v, i) =>
					i === id ? (v.isActive = true) : (v.isActive = false)
				);
			},
		},
	};
</script>
<style lang="less" scoped>
</style>